<template>
  <div class="ui-pagemark-comingsoon">
    <div class="container pt-4 pb-5" style="max-width: 1000px;">
      <img src="~@/assets/static/pic/comingsoon_swap_1.png" style="max-width: 100%;max-width: 450px;">
    </div>
  </div>
</template>

<script>

export default {
  name: 'swap',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>